import axios from "axios"
import { GeolocationAutocompleteType, GeolocationPlaceType } from "ui/types/api-integrations"

type GeoTypes = "geocode" | "locality"

export const GeoService = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
})
GeoService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    return Promise.reject(error)
  },
)

const autocomplete = (q: string, types: GeoTypes = "geocode", lang = "pl") =>
  GeoService.get<null, GeolocationAutocompleteType[]>(
    `https://autocomplete-ki6gvzx6ua-uc.a.run.app?q=${q}&types=${types}&lang=${lang}`,
  )

const place = (id: string, lang = "pl") =>
  GeoService.get<null, GeolocationPlaceType>(
    `https://place-ki6gvzx6ua-uc.a.run.app?id=${id}&lang=${lang}`,
  )

export const GeolocationService = {
  autocomplete,
  place,
}
